import clsx from 'clsx'
import * as React from 'react'

import { v4 as uuidv4 } from 'uuid'
import { Logger } from 'src/3rds/cube'

import { makeStyles } from 'tss-react/mui'

import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import IconButton from '@mui/material/IconButton'

import { useContainer } from 'src/utils/views/useContainer'

import { Avatar, Box, Typography } from '@mui/material'
import { AppStorage } from 'src/utils'
import { MainScope } from '../../Main.scopes'

const LOG = Logger.get('MainView/UserInfoMenuButton')
const appStorage = AppStorage.singleton()

const useStyles = makeStyles()((theme) => ({
    button: {},
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5)
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        lineHeight: 1.1,
        textAlign: 'right'
    },
    name: {
        fontSize: '0.9rem',
        color: '#fffffff2',
        fontWeight: 500,
        margin: 0,
        padding: 0
    },
    role: {
        fontSize: '0.7rem',
        color: '#ffffffad',
        margin: 0,
        padding: 0
    }
}))

export type UserInfoMenuButtonProps = {
    className?: string
    mainScope: MainScope
}

export default function UserInfoMenuButton({ className, mainScope }: UserInfoMenuButtonProps) {
    const container = useContainer()
    const uuid = React.useMemo(uuidv4, [])
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = React.useCallback((evt: React.MouseEvent<HTMLButtonElement>) => {
        if ((evt.ctrlKey && evt.shiftKey) || (evt.shiftKey && evt.altKey)) {
            mainScope.onToggleComplianceMode().catch(LOG.caught)
            evt.preventDefault()
            evt.stopPropagation()
            return
        }
        setAnchorEl(evt.currentTarget)
    }, [])

    const handleClose = React.useCallback(() => {
        setAnchorEl(null)
    }, [mainScope])

    const handleProfile = React.useCallback(() => {
        setAnchorEl(null)
        mainScope.onProfile().catch(LOG.caught)
    }, [mainScope])

    const handleSignOut = React.useCallback(() => {
        setAnchorEl(null)
        mainScope.onSignOut().catch(LOG.caught)
    }, [mainScope])

    const { classes } = useStyles()

    return (
        <>
            <IconButton
                className={clsx(classes.button, className)}
                aria-controls={open ? uuid : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <Box className={classes.root}>
                    <Box className={classes.textContainer}>
                        <Typography className={classes.name}>{appStorage.userName || 'Usuário'}</Typography>
                        <Typography className={classes.role}>{appStorage.userPosition || ''}</Typography>
                    </Box>

                    <Avatar
                        src={(appStorage.userName || 'Usuário')[0].toUpperCase()}
                        alt={appStorage.userName || 'Usuário'}
                        sx={{ width: 36, height: 36 }}
                    />
                </Box>
            </IconButton>
            <Menu
                id={uuid}
                anchorEl={anchorEl}
                container={container}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': uuid
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                
            >
                <MenuItem onClick={handleProfile}>Informações do Perfil</MenuItem>
                <MenuItem onClick={handleSignOut}>Sair</MenuItem>
            </Menu>
        </>
    )
}
